import { render } from "./ModalRangoFechas.vue?vue&type=template&id=616e5890"
import script from "./ModalRangoFechas.vue?vue&type=script&lang=js"
export * from "./ModalRangoFechas.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__